<template>
  <div>
    <a-tree-select
      :multiple="multiple"
      :placeholder="placeholder"
      :fieldNames="{ label: 'name', value: 'id' }"
      :tree-data="treeData"
      :value="value"
      allow-clear
      class="w100"
      show-search
      tree-node-filter-prop="title"
      @change="onChange"
      @clear="onClear"
      @select="onSelect"
      :disabled="disabled"
      :virtual="false"
    >
    </a-tree-select>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, watch } from "vue";
import { DepartmentService } from "@/views/organization/department/department.service";
import { message } from "ant-design-vue";
import _ from "lodash";

/**
 * 组织架构选择器
 * <department-tree-select v-model:value="formRef.departmentId"></department-tree-select>
 */
export default defineComponent({
  isGlobal: true,
  name: "DepartmentTreeSelect",
  props: {
    placeholder: {
      type: String,
      default: "请选择",
    },
    value: {
      type: String,
      default: undefined,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    currentId: {
      type: String,
      default: undefined,
    },
    isDisabledDown: {
      type: Boolean,
      default: false,
    },
    // 是否有劳务班组
    staffType: { type: [String], default: "no_type" },
  },
  emits: ["update:value", "select","setLoading"],
  setup(props, { emit }) {
    const { data, run, loading } = DepartmentService.useSimpleListApi();
    let disabledId: any = ref([]);
    let treeData = ref();
    const onChange = (id) => {
      emit("update:value", id);
    };

    const onClear = () => {
      emit("update:value", "");
    };

    const onSelect = (id, e) => {
      emit("select", { id, name: e.name });
    };

    const search = async () => {
      await run({ staffType: props.staffType });
    };
    const handleTree = (id) => {
      function handle(arr, isd?) {
        arr.forEach((item) => {
          if (id == item.id || isd) {
            item.disabled = true;
          }
          if ((id == item.id || isd) && item.children) {
            handle(item.children, true);
          }
          if (!(id == item.id || isd) && item.children) {
            handle(item.children, false);
          }
          // console.log("🚀 ~ file: index.vue:137 ~ arr.forEach ~ item:", item);
        });
      }
      handle(treeData.value);
      // console.log("🚀 ~ file: index.vue:147 ~ handleTree ~ treeData.value:", treeData.value);
    };

    watch(
      () => props.currentId,
      async (n) => {
        // console.log("🚀 ~ file: index.vue:136 ~ n:", n);
        disabledId.value = [];
        emit("setLoading", true);

        await search();
        treeData.value = _.cloneDeep(data.value?.records);
        if (n) {
          disabledId.value.push(n);
        }
        if (props.isDisabledDown) {
          handleTree(n);
        }
        emit("setLoading", false);

      },
      {
        immediate: true,
      }
    );
    onMounted(async () => {
      // await search();
      // treeData.value = _.cloneDeep(data.value?.records);
    });

    return {
      data,
      loading,
      search,
      onChange,
      onClear,
      onSelect,
      disabledId,
      treeData,
    };
  },
});
</script>
